import { useFeatureFlag } from '@/composables/featureFlags.js'
import { useLocumUserQuery } from '@/composables/locum.js'
import { useAuth } from '@/composables/useAuth.js'
import { isSamePage } from '@/utils/middleware.js'
export default defineNuxtRouteMiddleware(async (to, from) => {
  if (isSamePage(to, from)) {
    return
  }

  if (to.name === 'provetId-auth-locum') {
    return
  }

  const isLocumManagementFeatureEnabled = useFeatureFlag(
    'temporary.new_frontend.locum_management',
  )

  const { user } = useAuth()
  const isLocum = computed(
    () =>
      user.value?.attributes?.is_locum && isLocumManagementFeatureEnabled.value,
  )

  if (!isLocum.value) {
    return
  }

  const locumUserDetail = useLocumUserQuery(user.value.id ?? '')

  await until(() => locumUserDetail.isSuccess || locumUserDetail.isError).toBe(
    true,
    { timeout: 5000, throwOnTimeout: false },
  )

  const permanent =
    locumUserDetail.data?.relationships?.available_departments_permanent ?? []
  const nonPermanent =
    locumUserDetail.data?.relationships?.available_departments_non_permanent ??
    []

  const hasNoDepartments = permanent.length === 0 && nonPermanent.length === 0

  if (!locumUserDetail.isSuccess || hasNoDepartments) {
    return navigateTo({ name: 'provetId-auth-locum' }, { replace: true })
  }
})
